module.exports = __webpack_public_path__ + "static/img/pro4.b024cef1.png";